import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 16m0 1.5a1.5 1.5 0 0 1 1.5 -1.5h11a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1 -1.5 1.5h-11a1.5 1.5 0 0 1 -1.5 -1.5z","key":"svg-0"}],["path",{"d":"M12 16q -2.5 -8 -6 -8q -2.5 0 -3 2c2.953 .31 3.308 3.33 4 6","key":"svg-1"}],["path",{"d":"M12 16q 2.5 -8 6 -8q 2.5 0 3 2c-2.953 .31 -3.308 3.33 -4 6","key":"svg-2"}],["path",{"d":"M9 9.5q 2 -3.5 3 -3.5t 3 3.5","key":"svg-3"}]]

const IconJoker = createReactComponent('outline', 'joker', 'Joker', __iconNode);

export default IconJoker;